import styled from 'styled-components';

export default styled.div`
  && {
    width: 100%;
    .inline {
      display: inline-block;
    }
    .header1 {
      height: 172px;
      background-color: rgba(193, 225, 141, 1);
      padding: 25px 40px;
      .icon1 {
        margin-right: 10px;
        margin-bottom: 25px;
        font-size: 20px;
      }
      .anticon-right {
        margin-top: 3px;
        font-size: 15px;
      }
      .ant-steps {
        background-color: white;
        border-radius: 23.5px;
        .ant-steps-item-icon {
          border-color: white;
          background: rgba(196, 196, 196, 1);
        }
      }
      .ant-steps {
        padding-right: 43%;
        padding-top: 15px;
        .ant-steps-item-icon {
          border-color: white;
          background: rgba(196, 196, 196, 1);
        }
      }
      .ant-steps-content:first-child {
        margin-right: -20px;
      }
      .ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:first-child {
        padding-left: 0;
        margin-right: -30px;
      }
      .ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:nth-child(2) {
        margin-right: 15px;
        margin-left: -20px;
      }
      .ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:nth-child(3) {
        margin-right: 15px;
      }
      .ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:nth-child(4) {
        margin-right: 15px;
      }
      .ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:nth-child(5) {
        margin-right: 20px;
      }
      .ant-steps-navigation .ant-steps-item-container {
        padding-bottom: 10px;
      }
      .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
        color: white;
      }
      .ant-steps-navigation .ant-steps-item::after {
         {
          left: 85%;
        }
      }
      .ant-steps-item-process {
        .ant-steps-item-icon {
          background: #c1e18d;
          border-color: white;
        }
        font-family: Hiragino Kaku Gothic Pro;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 21px;
      }
      .ant-steps-item-wait {
        font-family: Hiragino Kaku Gothic Pro;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
      }
      .ant-steps-item::before {
        display: none;
      }
    }
    .header2 {
      height: 68px;
      background-color: rgba(236, 255, 184, 1);
      padding-right: 65px;
      padding-left: 80px;
      display: flex;
      align-items: center;
      .anticon-plus {
        font-size: 25px;
      }
    }
    .last {
      left: -85px;
    }
  }
`;
